/**
 * Attribution parameter keys used across analytics tracking
 */

/** Facebook Click ID parameter */
export const FBCLID_KEY = 'fbclid'

/** UTM parameter keys */
export const UTM_PARAM_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_ad',
    'utm_id',
]

/** Google Ads specific parameter keys (URL query param names) */
export const GOOGLE_ADS_PARAM_KEYS = [
    'gclid',
    'adset',
    'network',
    'matchtype',
    'device',
]

/** Google iOS 14.5+ conversion tracking parameter keys */
export const GOOGLE_IOS_PARAM_KEYS = ['wbraid', 'gbraid']

/** TikTok parameter keys */
export const TIKTOK_PARAM_KEYS = ['ttclid']

/** Snapchat parameter keys */
export const SNAPCHAT_PARAM_KEYS = ['ScCid']

/** Impact Radius parameter keys */
export const IMPACT_RADIUS_PARAM_KEYS = ['clickid', 'im_ref']

/** Meta Pixel trait keys for Segment */
export const META_PIXEL_TRAIT_KEYS = ['fbc', 'fbp', 'fbclid']

/** All attribution parameter keys including UTM, Google Ads params, and click IDs */
export const ATTRIBUTION_PARAM_KEYS = [
    ...UTM_PARAM_KEYS,
    ...GOOGLE_ADS_PARAM_KEYS,
    ...GOOGLE_IOS_PARAM_KEYS,
    ...TIKTOK_PARAM_KEYS,
    ...SNAPCHAT_PARAM_KEYS,
    FBCLID_KEY,
]

/** PII keys that should only be stored in user profile, NOT in events */
export const PII_KEYS = [
    'firstName',
    'lastName',
    'dateOfBirth',
    'birthday', // Same as dateOfBirth but in ISO format (YYYY-MM-DD) for Segment
    'email',
    'phone',
]

/** User attribute keys that should only be tracked once (immutable or rarely change) */
export const TRACK_ONCE_KEYS = [FBCLID_KEY, ...META_PIXEL_TRAIT_KEYS]
